import React, { FC } from "react";
import { SizeUnit } from "../types";

interface SizeUnitPickerProps {
  value: SizeUnit;
  onChange: (unit: SizeUnit) => void;
}

const SizeUnitPicker: FC<SizeUnitPickerProps> = ({ value, onChange }) => {
  return (
    <div className="flex items-center text-themed-textSecondary gap-[5px] select-none w-[50px]">
      <span
        onClick={() => onChange(SizeUnit.PIXEL)}
        className={`cursor-pointer hover:text-themed-text ${
          value === SizeUnit.PIXEL ? "text-themed-text" : ""
        }`}
      >
        PX
      </span>
      <span>|</span>
      <span
        onClick={() => onChange(SizeUnit.PERCENTAGE)}
        className={`cursor-pointer hover:text-themed-text ${
          value === SizeUnit.PERCENTAGE ? "text-themed-text" : ""
        }`}
      >
        %
      </span>
    </div>
  );
};

export default SizeUnitPicker;
